/**
 * @desc 关联订单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.AssociateSkuParamDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/associateSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
